<template>
  <li :style="designCardId === 3 ? 'min-height: 160px;' : 'min-height: 220px;'">
    <StorePasswordModal v-if="isModalOpen" :store="store" :isModalOpen="isModalOpen" @closeStorePasswordModal="closeStorePasswordModal"/>
    <StoreWarningModal
      :isOpen="warningModalState"
      :warning="currentWarning"
      :storeName="store?.name || ''"
      @close="closeWarningModal"
    />
    <div class=" inline" @click="handleStoreRedirection" >
      <!-- {{ store.has_password  }} -->
      <div @click="() => onStoreClick(store)"
        :class="`${appendedClass} ${getCardBackgroundClass()} flex flex-col store-item mx-0.5 relative cursor-pointer pt-3 md:pt-4 pb-2.5 md:pb-3 px-[0.35rem] md:px-[0.5rem] text-center items-center justify-center active:border-black/30`"
        :style="{ height: designCardId === 3 ? '155px' : 'auto' }">
        <!-- Design Card 3 Layout -->
        <template v-if="designCardId === 3">
          <div class="w-full flex justify-between items-center mb-4">
            <!-- Followers Count -->
            <div v-if="store.followers_count > 0" class="flex items-center gap-1">
              <img :src="followers_icon" width="14" height="14" alt="followers" />
              <span class="text-[0.72rem] text-[#515151]">{{ arabizeNumbers(store.followers_count || 0) }}</span>
            </div>
            
            <!-- Rating -->
            <div v-if="isRatingAvailable" class="flex items-center gap-1">
              <span class="text-[0.72rem] text-[#191C1B]">{{ arabizeNumbers(Number(store.ratings_avg)) }}</span>
              <img :src="starIcon" width="14" height="14" alt="starIcon" />
            </div>
          </div>

          <!-- Store Logo with Verified Badge -->
          <div class="relative mb-2">
            <div class="image-container w-[4.375rem] h-[4.375rem] flex justify-center items-center p-0 box-border select-none rounded-[50%] overflow-hidden">
              <img :draggable="false" @error="onImageError" :src="store.logo || placeholderImg"
                :class="`${designCardId === 3 ? 'h-[5rem] w-[5rem] lg:w-[5.5rem] lg:h-[5.5rem] xl:w-[6rem] xl:h-[6rem]' : 'h-[3.70rem] w-[3.70rem] lg:w-[4rem] lg:h-[4rem] xl:w-[4.2rem] xl:h-[4.2rem]'} rounded-full object-cover bg-gray-100`"
                alt="" loading="eager" :width="97" :height="97" />
            </div>
            <img v-if="!!store.verified" :src="VerifiedIcon" height="20" width="20" alt=""
              class="absolute z-[1] top-[-0.5rem] right-[-0.5rem] w-[1.25rem] h-[1.25rem]" />
          </div>

          <!-- Store Name -->
          <div class="inline-flex flex-nowrap items-center gap-2 shrink-1 min-w-0 mb-2">
            <span class="text-[0.72rem] md:text-[0.8rem] 3xl:text-[0.813rem] ellipsis-x2 font-bold break-words text-[#191C1B]">
              {{ store.name }}
            </span>
            <!-- Warning Icon -->
            <button
              v-if="shouldShowWarningIcon"
              type="button"
              @click.stop="openWarningModal"
              class="flex items-center justify-center w-5 h-5 text-sm leading-none text-yellow-500 hover:text-yellow-600 transition-colors cursor-pointer shrink-0"
              :title="$t('panel.warning_details') || 'Warning details'"
              aria-label="warning-details"
            >
              ⚠️
            </button>
          </div>

          <!-- Follow Button -->
          <div v-if="withFollowButton" class="flex justify-center mb-1 w-full mt-auto">
            <FollowUnfollowButton :appendedClass="buttonStyle" class="mt-2" :storeName="storeName" :toggleFollowingState="toggleFollowingState" :followed="followed"
            :followingInProgress="followingInProgress" :designId="2" />
          </div>
        </template>

        <!-- Original Layout for other design cards -->
        <template v-else>
          <!-- store verification icon -->
          <img v-if="!!store.verified" :src="VerifiedIcon" height="20" width="20" alt=""
            class="absolute z-[1] top-[0.45rem] w-[1.25rem] h-[1.25rem] rtl:right-2 right-auto ltr:left-2 left-auto" />
          
          <!-- Random Hashtag -->
          <!-- <div v-if="randomHashtag" 
            class="absolute top-2 rtl:left-2 ltr:right-2 flex items-center gap-1 bg-primary/10 text-primary px-2 py-0.5 rounded-full">
            <span class="text-[8px]">{{ randomHashtag?.name }}</span>
          </div> -->
          
          <!-- delete store from log list -->
          <div v-if="hasDeleteItem" class="absolute top-8 rtl:right-1 rtl:left-auto right-auto left-1">
            <client-only>
              <button type="button" @click="allowToRemoveItem"
                :class="` z-10 bg-white hover:brightness-90 transition-[filter,transform] duration-150 shadow-[0px_3px_6px_#00000029] w-[2.20rem] h-[2.20rem] 3xl:w-[2.25rem] 3xl:h-[2.25rem] rounded-full`.trim()">

                <span
                  class=" flex justify-center items-center favorite__btn select-none w-full h-full bg-transparent border-0 cursor-pointer rounded-[6px] md:rounded-[7px]mx-auto mb-[-0.25rem]"
                  title="delete">
                  <img class="object-contain heart heart-icon mx-auto mb-0.5 w-[10px]" :draggable="false"
                    src="../../assets/icons/Delete.svg" alt="delete" />
                  <!-- <span class="sr-only">{{ liked ? 'Unfavorite' : 'Favorite' }}</span> -->
                </span>
              </button>
            </client-only>
          </div>
          <!-- store image -->
      
          <div class="flex flex-col items-center justify-center text-center mb-auto mt-[10px]">
            <div
                class="image-container w-[4.375rem] h-[4.375rem] flex justify-center items-center p-0 box-border select-none rounded-[50%] overflow-hidden">
                <img :draggable="false" @error="onImageError" :src="store.logo || placeholderImg"
                  :class="`${designCardId === 3 ? 'h-[5rem] w-[5rem] lg:w-[5.5rem] lg:h-[5.5rem] xl:w-[6rem] xl:h-[6rem]' : 'h-[3.70rem] w-[3.70rem] lg:w-[4rem] lg:h-[4rem] xl:w-[4.2rem] xl:h-[4.2rem]'} rounded-full object-cover bg-gray-100`"
                  alt="" loading="eager" :width="97" :height="97" />
                <!-- <NuxtImg
                            :draggable="false"
                              @error="onImageError"
                              :src="store.logo || placeholderImg"
                              class="w-full h-full object-cover bg-gray-100"
                              :alt="store.name"
                              loading="lazy"
                              width="97"
                              height="97" /> -->
              </div>
              <!-- store name -->
              <div class="inline-flex flex-nowrap items-center gap-2 shrink-1 min-w-0">
                <span
                  class="text-[0.72rem] md:text-[0.8rem] 3xl:text-[0.813rem] ellipsis-x2 font-bold mt-1 mb-0.5 break-words text-[#191C1B]">{{
            store.name }}</span>
                <!-- Warning Icon -->
                <button
                  v-if="shouldShowWarningIcon"
                  type="button"
                  @click.stop="openWarningModal"
                  class="flex items-center justify-center w-5 h-5 text-sm leading-none text-yellow-500 hover:text-yellow-600 transition-colors cursor-pointer shrink-0"
                  :title="$t('panel.warning_details') || 'Warning details'"
                  aria-label="warning-details"
                >
                  ⚠️
                </button>
              </div>
          </div>

          <!-- category name -->
          <span
            class="text-[0.7rem] md:text-[0.71rem] 3xl:text-[0.75rem] font-medium w-full p-0 mb-auto line-clamp-1 md:line-clamp-2 ellipsis-x1 text-center text-primary"
            style="display: contents !important;"
            :title="firstCategoryName">{{ firstCategoryName }}</span>
          <!-- store rating -->
          <span v-if="isRatingAvailable" class="gap-1 w-max pr-1.5 pl-2.5 rtl:pl-1.5 rtl:pr-2.5 pb-0.5 text-[#191C1B] font-medium text-[0.72rem] md:text-[0.8rem] 3xl:text-[0.813rem] flex items-center">
            <span>{{
        arabizeNumbers(
          Number(store.ratings_avg).toLocaleString()
        )
      }}</span>
            <img :src="starIcon" width="14" height="14" alt="starIcon" />
          </span>
          <!-- store products, or followers, or views, or ratings, or orders count -->
          <span v-if="sortStoresByCondition()"
            class="text-[#515151] mt-0.5 text-[0.7rem] md:text-[0.71rem] 3xl:text-[0.75rem] font-medium">
            {{sortStoresByConditionCount() == 0 ? '' : sortStoresByConditionText() + ' (' + arabizeNumbers(sortStoresByConditionCount()) + ')' }}
          </span>
          <!-- follow/unfollow button -->
        <div v-if="withFollowButton" class="flex justify-center mb-1 w-full mt-auto">
          <FollowUnfollowButton :appendedClass="buttonStyle" class="mt-2" :storeName="storeName" :toggleFollowingState="toggleFollowingState" :followed="followed"
          :followingInProgress="followingInProgress" :designId="2" />
        </div>

        </template>
      </div>
    </div>
  </li>
</template>

<script>
import {
  ROUTESNAMES,
  arabizeNumbers,
  roundWithHalf,
  onImageError,
  buildStoreLink
} from "@/helpers";
import starIcon from "@/assets/images/star.svg";
import VerifiedIcon from "@/assets/icons/9224364_verified_check_mark_verification_badge_icon.svg";
import FollowUnfollowButton from "@/components/user/store/FollowUnfollowButton.vue";
import StorePasswordModal from "@/components/user/StorePasswordModal.vue";
import StoreWarningModal from "@/components/user/store/StoreWarningModal.vue";
import followers_icon from "@/assets/icons/followers_icon.svg";
export default {
  data() {
    return {
      VerifiedIcon,
      ROUTESNAMES,
      starIcon,
      followers_icon,
      followingInProgress: false,
      followed: 0,
      isModalOpen:false,
      warningModalState: false,
      currentWarning: null,
    }
  },
  props: {
    store: {
      type: Object,
      required: true,
      default: () => ({})
    },
    usedCookieLanguage: {
      type: String,
      required: true,
      default: 'ar'
    },
    hasDeleteItem:{
          type: Boolean,
          default: false,
        },
    buttonStyle: {
      type: String,
      required: true,
      default: 'inline-block'
    },
    fromSingleStorePage: {
      type: Boolean,
      required: false,
      default: false,
    },
    storesType: {
      type: String,
      required: false,
      default: 'main',
    },
    placeholderImg: {
      type: String,
      required: true,
      default: '',
    },
    openBranchModal: {
      type: Function,
      required: false
    },
    appendedClass: {
      type: String,
      required: false,
      default: "w-[8rem] sm:w-[9rem] sm:mx-1 md:w-[9.170rem] lg:w-[9.270rem] 3xl:w-[9.810rem] rounded-[0.5rem] h-full max-h-[12.188rem] md:max-h-[12.5rem]",
    },
    withFollowButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    designCardId: {
      type: Number,
      required: false,
      default: 1,
    },
    sortStoresBy: {
      type: String,
      required: false,
      default: '',
    },
    fromStorePage: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  components: {
    FollowUnfollowButton,
    StorePasswordModal,
    StoreWarningModal,
  },
  methods: {
    arabizeNumbers,
    roundWithHalf,
    onImageError,
    buildStoreLink,
    getCardBackgroundClass() {
      if (this.fromStorePage) {
        return 'bg-[#F8F9FF] mt-6';
      } else {
        return this.designCardId == 1 || this.designCardId == 3 ? 'bg-[#F6F6F6]' : 'bg-white';
      }
    },
    sortStoresByCondition(){
      switch (this.$props.sortStoresBy) {
        case 'most_followed':
          return true;
        case 'most_products':
          return true;
        case 'most_viewed':
          return true;
        case 'top_rated':
          return true;
        case 'best_seller':
          return true;
        default:
          return false;
      }
    },
    sortStoresByConditionCount(){
      switch (this.$props.sortStoresBy) {
        case 'most_followed':
          return this.store.followers_count;
        case 'most_products':
          return this.store.products_count;
        case 'most_viewed':
          return this.store.views;
        case 'top_rated':
          return this.store.ratings_count;
        case 'best_seller': 
          return this.store.orders_count == -1 ? this.store.followers_count : this.store.orders_count;
        default:
          return 0;
      }
    },
    sortStoresByConditionText(){
      switch (this.$props.sortStoresBy) {
        case 'most_followed':
          return this.$t('general.list_sorting.followed');
        case 'most_products':
          return this.$t('general.list_sorting.products');
        case 'most_viewed':
          return this.$t('general.list_sorting.views');
        case 'top_rated':
          return this.$t('general.list_sorting.rating_count');
        case 'best_seller':
          return this.store.orders_count == -1 ? this.$t('general.list_sorting.followed') : this.$t('general.list_sorting.orders_count');
        default:
          return '';
      }
    },
    allowToRemoveItem(event) {
      event.stopPropagation();
      event.preventDefault();
      // prepareItemToDelete(item){
        this.$emit('prepareItemToDelete' , this.store)
      // } 
    },
    handleStoreRedirection(){
      // <!-- :to="storesType == 'main' ? buildStoreLink(store && store.username) : '#'" -->

// check if store has password 
const hasPassword =  this.$props.store?.has_password


      if(hasPassword){

        this.isModalOpen = true;

      }else{



        const url =  this.buildStoreLink(this.$props.store && this.$props.store.username);

        this.$router.push(url)
      }

      
    },
    closeStorePasswordModal(val){
      if(typeof val == 'boolean'){
        this.isModalOpen = val;
      }

    },
    onStoreClick(store) {
      if (this.storesType == "branch") {
        this.openBranchModal(store);
      }
    },
    setTheFollowingState ( isFollowed ) {
      this.followed = isFollowed;
    },
    toggleFollowingState() {
            const { id } = this.store || {};
            const isOffline = !navigator.onLine;
            if (this.followingInProgress || !id || isOffline) {
                return;
            }
            this.followingInProgress = true;
           
            if(this.isUserLoggedIn){
              this.setTheFollowingState( !this.followed );
            }

            const bodyRequest = {
                store_id: id
            };
            
            this.makeRequest({
                owner: this.MAINROLES.user,
                url: this.APIREQUESTS.user.followStore.url,
                method: this.APIREQUESTS.user.followStore.method,
                formData: JSON.stringify(bodyRequest)
            })
                .then(res => {
                    if (!res?.status) {
                        this.setTheFollowingState( this.isFollowing );
                        // fail
                        this.notify({
                            type: "error",
                            msg: res?.message || this.$t("general.failed")
                        });
                    } else {
                        // success
                        this.setTheFollowingState( +res.data?.following);
                    }
                })
                .catch(err => {
                  // fail
                    this.setTheFollowingState( this.isFollowing );
                    // console.error(err);
                    this.notify({
                        type: "error",
                        msg:
                            (typeof err === "string" ? err : err?.data?.message) ||
                            this.$t("general.failed")
                    });
                })
                .finally(() => {
                    this.followingInProgress = false;
                });
    },
    openWarningModal() {
      if (this.store?.latest_warning) {
        this.currentWarning = this.store.latest_warning;
        this.warningModalState = true;
      }
    },
    closeWarningModal() {
      this.warningModalState = false;
      this.currentWarning = null;
    },
  },
  computed: {
    finalizedNameKey() {
      return this.nameKey || `name_${this.usedCookieLanguage}`;
    },
    isFollowing() {
      return !!this.store?.following;
    },
    firstCategoryName(){
      return this.store?.categories?.[0]?.[this.finalizedNameKey];
    },
    isRatingAvailable(){
      const ratingAvg = this.store?.ratings_avg;
      return (typeof ratingAvg === 'string' || typeof ratingAvg === 'number') && parseInt(ratingAvg) > 0;
    },
    storeName(){
      return this.store?.name;
    },
    randomHashtag() {
      return this.store?.hashtags?.[Math.floor(Math.random() * this.store?.hashtags?.length)] || null;
    },
    shouldShowWarningIcon() {
      const warning = this.store?.latest_warning;
      const myStore = this.store?.my_store;
      
      if (!warning || !warning.type) return false;
      
      // For 'first' warning, only show if my_store is true
      if (warning.type === 'first') {
        return myStore === true || myStore === 1;
      }
      
      // For 'second' and 'third' warnings, show for everyone
      return warning.type === 'second' || warning.type === 'third';
    },
  },
  mounted(){
    this.setTheFollowingState(!!this.isFollowing );
  }
}
</script>

<style lang="scss" scoped>
.store-item {
  flex: 0 0 160px;
  overflow: hidden;
  transition: transform 0.15s ease-out, box-shadow 0.2s ease;
  border: 1px solid transparent;
  
  @media only screen and (max-width: 670px) {
    flex: 0 0 150px;
  }
  
  .image-container {
    /* GPU acceleration for smoother rendering */
    transform: translateZ(0);
    -webkit-transform: translateZ(0);
    will-change: transform;
    
    img {
      transition: transform 0.2s ease-in-out;
      /* Optimize image rendering */
      image-rendering: -webkit-optimize-contrast;
      image-rendering: crisp-edges;
      backface-visibility: visible;
      -webkit-backface-visibility: visible;
    }
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    border-color: rgba(0, 0, 0, 0.05);
    
    .image-container {
      img {
        transform: scale(1.08);
      }
    }
  }

  // Add specific styles for design card 3
  &[class*="designCardId-3"] {
    .image-container {
      margin: 0 auto;
    }
    // Add reduced height for design card 3
    max-height: 10rem;
  }
  
  // Enhanced styling for fromStorePage cards
  &.bg-\[\#F8F9FF\] {
    border-left: 3px solid #6366F1;
    box-shadow: 0 2px 8px rgba(99, 102, 241, 0.08);
    
    &:hover {
      box-shadow: 0 4px 12px rgba(99, 102, 241, 0.12);
      border-color: #6366F1;
      background-color: #F5F7FF !important;
    }
  }
}

// Add additional styling for better visual hierarchy
li {
  transition: all 0.2s ease;
  
  .store-item {
    border-radius: 0.75rem;
    
    span {
      transition: color 0.15s ease;
    }
  }
}
</style>